import React from 'react';
import CommonPageHeader from '../../../components/CommonPageHeader/CommonPageHeader';
import PageHelmet from '../../../components/shared/PageHelmet';
import MainFooter from '../../../components/MainFooter/MainFooter';
import NavHeader from '../../../components/NavHeader/NavHeader';
import KeyFeatures from '../KeyFeatures/KeyFeatures';
import OurApproach from '../../Home/OurApproach/OurApproach';
import AdditionalServices from '../AdditionalServices/AdditionalServices';
import { ChartArea, FileJson, CalendarSync, Binoculars, MonitorCog, MonitorSmartphone, GlobeLock, DatabaseZap } from 'lucide-react';
import OurExpertise from '../../../components/OurExpertise/OurExpertise';
import { Link } from 'react-router-dom';

const OurExpertiseData = [
    {
        id: 1,
        title: "Proactive Monitoring & Maintenance",
        icon: <Binoculars size="64" strokeWidth='1' />,
        content: "Our team leverages cutting-edge tools to proactively monitor your systems, detect anomalies, and ensure optimal performance around the clock."
    },
    {
        id: 2,
        title: "End-to-End Support",
        icon: <MonitorCog size="64" strokeWidth='1' />,
        content: "From troubleshooting technical issues to handling complex migrations, we provide comprehensive support that addresses all your IT needs."
    }
]

const KeyFeaturesData = [
    {
        id: 1,
        title: "Web & CMS Support",
        icon: <FileJson size="42" strokeWidth='1' />,
        content: "Expert troubleshooting and optimization for platforms like WordPress, Drupal, and Magento."
    },
    {
        id: 2,
        title: "Website Maintenance",
        icon: <ChartArea size="42" strokeWidth='1' />,
        content: "Regular updates, backups, and performance enhancements to ensure seamless operations."
    },
    {
        id: 3,
        title: "Web and Mobile Apps Maintenance",
        icon: <MonitorSmartphone size="42" strokeWidth='1' />,
        content: "Evaluate speed, scalability, and reliability to enhance the user experience and avoid potential bottlenecks."
    }
]

const AdditionalServicesData = [
    {
        id: 1,
        title: "Security Audits",
        icon: <GlobeLock size="54" strokeWidth='1' />,
        content: "Comprehensive assessments to protect against vulnerabilities and threats."
    },
    {
        id: 2,
        title: "Data Backup & Recovery",
        icon: <DatabaseZap size="54" strokeWidth='1' />,
        content: "Secure storage and swift recovery solutions for your critical data."
    },
    {
        id: 3,
        title: "Performance Optimization",
        icon: <CalendarSync size="54" strokeWidth='1' />,
        content: "Enhanced speed and efficiency to improve user experience."
    }
]

const OurApproachData = [
    {
        id: 1,
        title: <h3><Link to="/">Discovery</Link></h3>,
        img: "assets/img/project/discover_icon_white.svg",
        content: "Understand your goals through collaborative sessions."
    },
    {
        id: 2,
        title: <h3><Link to="/">Design</Link></h3>,
        img: "assets/img/project/design_icon_white.svg",
        content: "Deliver wireframes, prototypes, and scalable architectures focused on usability and performance."
    },
    {
        id: 3,
        title: <h3><Link to="/">Development</Link></h3>,
        img: "assets/img/project/develop_icon_white.svg",
        content: "Deliver wireframes, prototypes, and scalable architectures focused on usability and performance."
    },
    {
        id: 4,
        title: <h3><Link to="/">Quality Assurance</Link></h3>,
        img: "assets/img/project/define_icon_white.svg",
        content: "Ensure flawless functionality on all devices and platforms."
    },
    {
        id: 5,
        title: <h3><Link to="/">Launch & Support</Link></h3>,
        img: "assets/img/project/deliver_icon_white.svg",
        content: "Seamless deployment, app store submissions, and ongoing maintenance."
    }
]
const bgColors = ["#006ce0", "#001133", "#006ce0", "#001133", "#006ce0"];

const ITSupportManaged = () => {
    return (
        <>
            <PageHelmet
                pageTitle="IT Support & Managed Services"
                description="Proactive IT support and managed services from Harsoft Solutions — monitoring, maintenance, security audits, and end-to-end support for web and cloud infrastructure."
                keywords="IT Support, Managed Services, Software Development Company"
                path="/ITSupportManaged"
            />

            <NavHeader />
            <main>
                <CommonPageHeader title="IT Support & Managed" subtitle="IT Support & Managed" />
                <OurExpertise OurExpertiseData={OurExpertiseData} title="Our Expertise" subtitle="Keeping Your Digital Infrastructure Running Smoothly" content="We develop customized IT support plans to suit your unique business objectives. Whether you're a small startup or a large enterprise, our focus is on minimizing downtime, resolving issues efficiently, and enhancing performance so you can focus on growth." />
                <KeyFeatures KeyFeaturesData={KeyFeaturesData} />
                <AdditionalServices AdditionalServicesData={AdditionalServicesData} img="assets/img/expart/expart-1.jpg" />
                <OurApproach OurApproachData={OurApproachData} title="Our Process" bgColors={bgColors} />
            </main>
            <MainFooter />
        </>
    );
};

export default ITSupportManaged;
